import { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { deriveOnboarding } from '@orgus/protocol';
import type { OnboardingView } from '@orgus/protocol';
import { useOrgus } from '../../lib/store.ts';
import { useOnboarding } from './client.ts';
import type { Phase } from './client.ts';
import { onboardingFacts } from './model.ts';

/** The five steps as they stand right now, derived from live hub state plus what the hub recorded. */
export function useOnboardingView(): OnboardingView & { phase: Phase } {
  const e = useOrgus(useShallow((s) => ({ machines: s.machines, projects: s.projects, sessions: s.sessions, suggestions: s.suggestions })));
  const probes = useOnboarding((s) => s.probes);
  const state = useOnboarding((s) => s.state);
  const phase = useOnboarding((s) => s.phase);
  return useMemo(() => ({ ...deriveOnboarding(onboardingFacts(e, probes), state), phase }), [e, probes, state, phase]);
}
